/* eslint-disable import/no-unresolved */
import { Thermostat, WaterDropOutlined, ElectricBolt } from '@mui/icons-material';
import Iconify from 'src/components/iconify/Iconify';

const SENSOR_ICONS = {
  tempI: (props) => <Thermostat {...props} fontSize="" />,
  tempP1: (props) => <Iconify {...props} icon="mdi:thermometer-probe" />,
  humidI: (props) => <WaterDropOutlined {...props} fontSize="" />,
  pressure: (props) => <Iconify {...props} icon="ix:gauge" />,
  lid: (props) => <Iconify {...props} icon="system-uicons:box-open" />,
  imu: (props) => <ElectricBolt {...props} fontSize="" />,
  als: (props) => <Iconify {...props} icon="lets-icons:sun-light" />,
  carContainer: (props) => <Iconify {...props} icon="ph:shipping-container-duotone" />,
  carSeat: (props) => <Iconify {...props} icon="mdi:steering" />,
};

export default SENSOR_ICONS;
